import { Injectable, Type } from '@angular/core';

export interface RegisteredModal {
  key: string;
  loadComponent: () => Promise<Type<unknown>>;
  defaultProps?: Record<string, unknown>;
  cssClass?: string;
  backdropDismiss?: boolean;
  showBackdrop?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModalRegistryService {
  private readonly registrations = new Map<string, RegisteredModal>();

  register(
    key: string,
    loadComponent: () => Promise<Type<unknown>>,
    options?: {
      defaultProps?: Record<string, unknown>;
      cssClass?: string;
      backdropDismiss?: boolean;
      showBackdrop?: boolean;
    }
  ): void {
    this.registrations.set(key, { key, loadComponent, ...options });
  }

  get(key: string): RegisteredModal | undefined {
    return this.registrations.get(key);
  }
}
